import React, { Component } from "react";
import img_project_2 from "../public/images/proj_diochemie.png";
import img_project_3 from "../public/images/proj_shirahige.png";
import img_project_4 from "../public/images/proj_nikkasparks.png";
import img_project_5 from "../public/images/proj_yamamoto.png";
import img_project_6 from "../public/images/proj_rakuten.png";
import img_project_7 from "../public/images/proj_kousei.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExternalLinkAlt,
  faDesktop,
  faMobileAlt,
  faTabletAlt,
  faSmileWink,
} from "@fortawesome/free-solid-svg-icons";
import { Alert, Col, Row, Badge } from "reactstrap";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

class Projects extends Component {
  render() {
    const projectsData = [
      {
        name: "Rakuten Travel",
        description: (
          <>
            Rakuten Travel is a big hotel booking website. I contributed mainly
            on the front-end development of this website.
          </>
        ),
        year: "2020",
        image: img_project_6,
        imageSize: "80%",
        platforms: ["PC", "TABLET", "SP"],
        link: "https://travel.rakuten.com/",
      },
      {
        name: "Kousei Kindergarten School",
        description: (
          <>
            Kousei is a kindergarten school located in Fukui, Japan. I worked on
            both front-end and back-end features of this website.
          </>
        ),
        year: "2016",
        image: img_project_7,
        imageSize: "80%",
        platforms: ["PC", "SP"],
        link: "https://www.fukuikosei.jp/index.php",
      },
      {
        name: "Shirahige Jinja",
        description: (
          <>
            Shirahige Jinja is a shrine located in Fukui, Japan. I developed the
            mobile version of the page when I was working in{" "}
            <a
              href="https://www.tenseiph.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tensei Philippines Inc.
            </a>{" "}
            as a web developer.
          </>
        ),
        year: "2016",
        image: img_project_3,
        imageSize: "40%",
        isImgAlignCenter: true,
        platforms: ["SP"],
        link: "https://www.sirahige-jinja.com/",
      },
      {
        name: "Yamamoto Housings",
        description: (
          <>
            Yamamoto Housings is a construction company located in Fukui, Japan.
            This is one of the first websites I developed when I started working
            professionally as a web dev.
          </>
        ),
        year: "2017",
        image: img_project_5,
        imageSize: "80%",
        platforms: ["PC"],
        link: "http://yamamoto-mokuzai.com/index.php",
      },
      {
        name: "nikkasparks.co",
        description: (
          <>
            nikkasparks.co is a trusted skin care products seller. I created the
            whole website myself. BTW, the owner of the business is none other
            than my wife!
            <FontAwesomeIcon icon={faSmileWink} className="ml-1" />
          </>
        ),
        year: "2017",
        image: img_project_4,
        imageSize: "80%",
        platforms: ["PC", "TABLET", "SP"],
        link: "http://www.nikkasparks.com/",
      },
      {
        name: "DioChemie",
        description: (
          <>
            DioChemie is a manufacturer and innovator for specialty paints and
            coatings in the Philippines. I created the whole website myself.
          </>
        ),
        year: "2017",
        image: img_project_2,
        imageSize: "80%",
        platforms: ["PC", "TABLET", "SP"],
        link: "http://diochemie.com/",
      },
    ];

    return (
      <div
        className="tools-container text-center m-auto"
        id="projects"
        name="projects"
      >
        <div className="component-top-margin">
          <Fade up>
            <h1 className="common-component-title mb-5">PROJECTS</h1>
          </Fade>
          {projectsData.map((project, idx) => {
            const isEven = idx % 2 === 0;
            const isLast = idx + 1 === projectsData.length;

            return (
              <Slide right={!isEven} left={isEven}>
                <Row
                  className={`justify-content-center portfolio-works ${
                    isLast ? "" : "portfolio-border-bottom"
                  }`}
                >
                  <Col
                    lg={{ size: 6, order: isEven ? 0 : 1 }}
                    className={
                      project.isImgAlignCenter
                        ? ""
                        : isEven
                        ? "text-lg-left"
                        : "text-lg-right"
                    }
                  >
                    <img
                      src={project.image}
                      alt={project.name}
                      width={project.imageSize}
                      className="mb-lg-0 mb-4 img-fluid"
                      loading="lazy"
                    />
                  </Col>
                  <Col
                    lg={{ size: 6, order: isEven ? 1 : 0 }}
                    className="text-left align-self-center"
                  >
                    <h3>{project.name}</h3>
                    <div className="d-flex align-items-center">
                      <Badge color="dark">{project.year}</Badge>
                      {project.platforms.includes("PC") && (
                        <FontAwesomeIcon icon={faDesktop} className="ml-3" />
                      )}
                      {project.platforms.includes("TABLET") && (
                        <FontAwesomeIcon icon={faTabletAlt} className="ml-2" />
                      )}
                      {project.platforms.includes("SP") && (
                        <FontAwesomeIcon icon={faMobileAlt} className="ml-2" />
                      )}
                    </div>
                    <p className="mt-3">{project.description}</p>
                    <a
                      className="btn btn-info rounded-0 projects-btn main-btn-color"
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faExternalLinkAlt}
                        className="mr-2"
                      />
                      Visit website
                    </a>
                  </Col>
                </Row>
              </Slide>
            );
          })}
          {/* <Slide up>
            <Alert color="info" className="mt-5 rounded-0">
              Other projects soon to be here...
            </Alert>
          </Slide> */}
        </div>
      </div>
    );
  }
}

export default Projects;
